import * as Yup from "yup";

export const editMemberSchema = Yup.object({
  EmailID: Yup.string().email().required("Please enter your email"),
  EmployeeId: Yup.string().required("Please enter employee id"),
  ClientId: Yup.string().required("Please select client"),
});
